@if (lorenzFormElement && isVisible) {

	<div [ngClass]="{
						valid: !lorenzFormElement.invalid,
						invalid: lorenzFormElement.invalid,
						enabled: lorenzFormElement.isVisible()
					}"
		 [title]="getTitle()"
		 (click)="onLeftClick($event)"
		 (contextmenu)="onRightClick($event)"
	>

	</div>

}
